const TrophyColoredIcon = () => {
  return (
    <svg
      fill="none"
      height="60"
      viewBox="0 0 60 60"
      width="60"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_328_10747)">
        <path
          d="M19.9567 36.2591H18.9418C18.4416 36.2591 18.0361 35.8537 18.0361 35.3535C18.0361 34.8534 18.4416 34.4479 18.9418 34.4479H19.9567C20.3604 34.4479 20.6889 34.1195 20.6889 33.7158C20.6889 33.4368 20.5339 33.186 20.2844 33.061L13.0923 29.4614C9.7818 27.8045 7.00363 25.264 5.05797 22.1145C3.1123 18.965 2.08398 15.3434 2.08398 11.6414V10.2228C2.08398 8.58624 3.41535 7.25476 5.05199 7.25476H15.7838C16.2839 7.25476 16.6894 7.66023 16.6894 8.16039C16.6894 8.66054 16.2839 9.06601 15.7838 9.06601H5.05188C4.41402 9.06601 3.89512 9.58492 3.89512 10.2228V11.6414C3.89512 15.0069 4.83004 18.2993 6.59887 21.1626C8.3677 24.0259 10.8934 26.3355 13.903 27.8418L21.0951 31.4413C21.9617 31.8751 22.5 32.7467 22.5 33.7157C22.5 35.1182 21.3592 36.2591 19.9567 36.2591Z"
          fill="#F7A738"
        />
        <path
          d="M41.0583 36.2591H40.0433C38.6409 36.2591 37.5 35.1181 37.5 33.7158C37.5 32.7466 38.0384 31.8752 38.905 31.4414L46.0971 27.8417C49.1067 26.3354 51.6325 24.0259 53.4013 21.1625C55.17 18.2993 56.105 15.0069 56.105 11.6414V10.2227C56.105 9.58486 55.5861 9.06595 54.9483 9.06595H44.2165C43.7163 9.06595 43.3109 8.66048 43.3109 8.16032C43.3109 7.66017 43.7163 7.2547 44.2165 7.2547H54.9483C56.5848 7.2547 57.9163 8.58607 57.9163 10.2227V11.6414C57.9163 15.3433 56.8879 18.9649 54.9423 22.1144C52.9966 25.264 50.2184 27.8045 46.9079 29.4614L39.7159 33.0609C39.4664 33.1858 39.3115 33.4366 39.3115 33.7156C39.3115 34.1193 39.64 34.4477 40.0437 34.4477H41.0586C41.5588 34.4477 41.9643 34.8532 41.9643 35.3533C41.9639 35.8536 41.5584 36.2591 41.0583 36.2591Z"
          fill="#F7A738"
        />
        <path
          d="M33.0935 39.8566V35.9166H26.9062V39.8566C26.9062 41.5998 25.9234 43.194 24.3661 43.9771L23.7442 44.2897C22.5681 44.8811 21.8259 46.0849 21.8259 47.4013V52.014H38.1739V47.4013C38.1739 46.0849 37.4318 44.8811 36.2557 44.2897L35.6338 43.9771C34.0764 43.194 33.0935 41.5998 33.0935 39.8566Z"
          fill="#FEC93E"
        />
        <path
          d="M36.2558 44.2897L35.6339 43.9771C34.0765 43.194 33.0937 41.5998 33.0937 39.8566V35.9166H30V52.014H38.1741V47.4013C38.1741 46.0849 37.4318 44.8811 36.2558 44.2897Z"
          fill="#EFB635"
        />
        <path
          d="M29.9999 39.2548C22.4911 36.2492 17.3512 29.2278 16.7553 21.1618L15.3716 2.42957H44.6283L43.2445 21.1618C42.6485 29.2278 37.5086 36.2492 29.9999 39.2548Z"
          fill="#FEC93E"
        />
        <path
          d="M38.8143 2.42957L37.4305 21.1618C37.0049 26.9209 34.2625 34.3692 29.9956 39.253C29.997 39.2536 29.9984 39.2542 29.9998 39.2548C37.5086 36.2492 42.6485 29.2278 43.2444 21.1618L44.6282 2.42957H38.8143Z"
          fill="#EFB635"
        />
        <path
          d="M45.9971 4.15834H14.0026C13.38 4.15834 12.8752 3.65361 12.8752 3.03099V1.12728C12.8752 0.504665 13.38 -6.10352e-05 14.0026 -6.10352e-05H45.9971C46.6197 -6.10352e-05 47.1245 0.504665 47.1245 1.12728V3.03088C47.1246 3.65349 46.6197 4.15834 45.9971 4.15834Z"
          fill="#F7A738"
        />
        <path
          d="M45.9972 2.07105H14.0027C13.411 2.07105 12.9268 1.61507 12.8799 1.03546C12.8775 1.06581 12.8752 1.09628 12.8752 1.12722V3.03081C12.8752 3.65343 13.38 4.15816 14.0026 4.15816H45.9971C46.6197 4.15816 47.1245 3.65343 47.1245 3.03081V1.12722C47.1245 1.09628 47.1222 1.06581 47.1198 1.03546C47.0731 1.61507 46.5889 2.07105 45.9972 2.07105Z"
          fill="#EA9632"
        />
        <path
          d="M44.2769 56.7818H15.7229V51.6083C15.7229 49.9013 17.1066 48.5176 18.8136 48.5176H41.1865C42.8934 48.5176 44.2772 49.9013 44.2772 51.6083V56.7818H44.2769Z"
          fill="#F7A738"
        />
        <path
          d="M41.1863 48.5176H37.951V52.1701C37.951 53.4389 36.9225 54.4675 35.6536 54.4675H15.7229V56.7819H44.2769V54.4675V51.6083C44.2769 49.9013 42.8932 48.5176 41.1863 48.5176Z"
          fill="#EA9632"
        />
        <path
          d="M46.7222 59.9999H13.2778C13.0831 59.9999 12.9253 59.842 12.9253 59.6474V56.4785C12.9253 56.2839 13.0831 56.126 13.2778 56.126H46.7222C46.9168 56.126 47.0747 56.2839 47.0747 56.4785V59.6474C47.0747 59.842 46.9168 59.9999 46.7222 59.9999Z"
          fill="#FEC93E"
        />
        <path
          d="M33.7438 40.3315H26.2563C25.322 40.3315 24.5645 39.574 24.5645 38.6396V38.094C24.5645 37.1597 25.322 36.4022 26.2563 36.4022H33.7438C34.6781 36.4022 35.4356 37.1597 35.4356 38.094V38.6396C35.4356 39.5741 34.6781 40.3315 33.7438 40.3315Z"
          fill="#FF8150"
        />
        <path
          d="M33.7438 38.3668H26.2563C25.5757 38.3668 24.9904 37.9639 24.722 37.3844C24.6219 37.6004 24.5645 37.8402 24.5645 38.0939V38.6395C24.5645 39.5738 25.322 40.3313 26.2563 40.3313H33.7438C34.6781 40.3313 35.4356 39.5738 35.4356 38.6395V38.0939C35.4356 37.8402 35.3782 37.6004 35.2781 37.3844C35.0096 37.9639 34.4244 38.3668 33.7438 38.3668Z"
          fill="#FD6E2E"
        />
        <path
          d="M30.2783 8.68013L32.3746 14.4687L38.5278 14.6737C38.8045 14.6829 38.9183 15.033 38.6998 15.2031L33.8424 18.9857L35.5489 24.901C35.6257 25.167 35.3278 25.3833 35.0986 25.2282L30 21.7774L24.9015 25.2282C24.6723 25.3833 24.3744 25.167 24.4511 24.901L26.1576 18.9857L21.3002 15.2031C21.0818 15.0331 21.1955 14.6829 21.4722 14.6737L27.6254 14.4687L29.7218 8.68013C29.8159 8.41986 30.1841 8.41986 30.2783 8.68013Z"
          fill="#F2EBDA"
        />
        <path
          d="M46.7222 56.126H40.7488V57.3784C40.7488 58.1185 40.1488 58.7185 39.4086 58.7185H13.2778C13.0831 58.7185 12.9253 58.5607 12.9253 58.366V59.6474C12.9253 59.842 13.0831 59.9999 13.2778 59.9999H46.7222C46.9168 59.9999 47.0747 59.842 47.0747 59.6474V58.366V56.4785C47.0747 56.2839 46.9168 56.126 46.7222 56.126Z"
          fill="#EFB635"
        />
      </g>
      <defs>
        <clipPath id="clip0_328_10747">
          <rect fill="white" height="60" width="60" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrophyColoredIcon;
